import Page from './page'

export default class Configuration {
    constructor(data) {
        this.homePage = null
        this.defaultBeatsPage = null
        this.songsPage = null
        this.soundkitsPage = null
        this.beatTapesPage = null
        this.servicesPage = null

        for (var i in data) {

            if (i == 'pagesConfig') {
                let pagesConfig = data[i]

                let beatPage

                for (var o = 0; o < pagesConfig.length; o++) {
                    let home = (o == 0)
                    pagesConfig[o] = new Page(pagesConfig[o], home)
                    if (home) {
                        this.homePage = pagesConfig[o]
                    }

                    if (!this.songsPage && pagesConfig[o].type == "songs") {
                        this.songsPage = pagesConfig[o]
                    }

                    if (!this.soundkitsPage && pagesConfig[o].type == "soundkits") {
                        this.soundkitsPage = pagesConfig[o]
                    }

                    if (!this.beatTapesPage && pagesConfig[o].type === "beattapes") {
                        this.beatTapesPage = pagesConfig[o]
                    }

                    if (!this.servicesPage && pagesConfig[o].type === "services") {
                        this.servicesPage = pagesConfig[o]
                    }

                    // Set defaultBeatPage to beat page displaying all beats else beat page displaying a playlist
                    if (!this.defaultBeatsPage && pagesConfig[o].type == "beats") {
                        if (pagesConfig[o].playlist_id) {
                            beatPage = pagesConfig[o]
                            continue
                        }
                        this.defaultBeatsPage = pagesConfig[o]
                    }
                }

                if (!this.defaultBeatsPage && beatPage != undefined) {
                    this.defaultBeatsPage = beatPage
                }

                this[i] = pagesConfig

            } else if (i == 'stylesConfig') {
                let stylesConfig = data[i]

                // Assigned highlighted license gradient values to separate variables to resolve issue of style
                // not updating immediately when user amends configuration
                if (stylesConfig.main.highlighted_license != undefined) {
                    stylesConfig.main.highlighted_license_gradient_1 = {
                        value: stylesConfig.main.highlighted_license.value[0]
                    }
                    stylesConfig.main.highlighted_license_gradient_2 = {
                        value: stylesConfig.main.highlighted_license.value[1]
                    }
                }

                this[i] = stylesConfig
            } else {
                this[i] = data[i];
            }
        }

        this.originalDefault = data.default

        if (this.storeTitle === '') {
            this.storeTitle = ab.user.name
        }
    }

    setPageNameIfUnique(page, newName) {
        // Replace leading and trailing white spaces
        let name = newName.replace(/^\s+|\s+$/g, "")
        // Replace multiple spaces with one
        name = name.replace(/\s\s+/g, " ");

        let unique = this.checkUniquePageName(newName, page)

        if (!unique) {
            return false
        }

        page.setName(name)
        return true
    }

    setName(name) {
        // Replace leading and trailing white spaces
        let newName = name.replace(/^\s+|\s+$/g, "")
        // Replace multiple spaces with one
        newName = newName.replace(/\s\s+/g, " ");

        if (newName.length == 0) return

        this.name = newName
    }

    setStoreTitle(storeTitle) {
        // Replace leading and trailing white spaces
        let newStoreTitle = storeTitle.replace(/^\s+|\s+$/g, "")
        // Replace multiple spaces with one
        newStoreTitle = newStoreTitle.replace(/\s\s+/g, " ");

        if (newStoreTitle.length == 0) return

        this.storeTitle = newStoreTitle
        document.title = this.storeTitle
    }

    /**
     * Get page by id.
     *
     * @param  {int} id
     * @return {object}
     */
    getPageById(id) {
        return this.pagesConfig.find((page) => id === page.id)
    }
    getPageByType(type) {
        return this.pagesConfig.find((page) => type === page.type)
    }
    /**
     * Delete page.
     *
     * @param  {object} page
     * @return {void}
     */
    deletePage(page) {
        let index = this.pagesConfig.findIndex((currentPage) => page.id === currentPage.id)

        if (index != -1) {
            this.pagesConfig.splice(index, 1)
        }
    }

    reorderPages(order) {
        let newOrder = []

        for (let pageId of order) {
            let pageForNewOrder = this.pagesConfig.find((page) => {
                return page.id == pageId
            })

            if (pageForNewOrder) {
                newOrder.push(pageForNewOrder)
            }
        }

        this.pagesConfig = newOrder

    }

    addPage(pageData) {

        let page = new Page(pageData)
        this.pagesConfig.push(page)
        return page
    }

    /**
     * Config has more than one page.
     * @return {Boolean}
     */
    hasMoreThanOnePage () {
        return this.pagesConfig.length === 1 ? false : true
    }

    /**
     * Config has an index page.
     * @return {Boolean}
     */
    hasIndexPage () {
        return (this.pagesConfig.find((page) => page.link == '/')) != undefined ? true : false
    }

    /**
     * Check unique page name.
     *
     * @param  {string}  name
     * @param  {object|Boolean} page
     * @return {Boolean}
     */
    checkUniquePageName(name, page = false) {
        return this.pagesConfig
                    .filter((currentPage) => (!page ? true : (currentPage.id !== page.id)))
                    .filter((currentPage) => name.toLowerCase() === currentPage.name.toLowerCase()).length ? false : true
    }

    /**
     * Get next page.
     *
     * @param  {object} page
     * @return {object}
     */
    getNextPage(page) {
        return this.pagesConfig
                    .map((currentPage, index, pages) => {
                        if (page.id === currentPage.id) {
                            if (pages[index + 1] != undefined) return pages[index + 1]
                            return pages[0]
                        }
                    }).find(page => page)
    }

    /**
     * Set Uploaded file as base64
     * with a given key.
     *
     * @param {file} file (base64)
     * @param {string} key
     * @return {void}
     */
    setUploadedFile (file, key) {
        this[key] = file;
    }

    /**
     * Remove an uploaded file
     * with a given key.
     *
     * @param  {bool} state
     * @param  {string} key
     * @return {void}
     */
    removeUploadedFile (state, key) {
        let payload = state ? true : false
        this[key] = payload;
    }

//    Replace two or more spaces with one
//    replace(/\s\s+/g, ' ');

}
